module.exports = __webpack_public_path__ + "static/org_codepath-8fef3f24fc9f2cbe7e1ba19156278734.png";